import { render, staticRenderFns } from "./listActivities.vue?vue&type=template&id=39357654&scoped=true&"
import script from "./listActivities.vue?vue&type=script&lang=js&"
export * from "./listActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39357654",
  null
  
)

export default component.exports